import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-short-label",
  templateUrl: "./field-set-short-label.component.html",
  styles: [],
})
export class FieldSetShortLabelComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
